import { render, staticRenderFns } from "./ReportDebtorDetail.vue?vue&type=template&id=afe09888&scoped=true&"
import script from "./ReportDebtorDetail.vue?vue&type=script&lang=js&"
export * from "./ReportDebtorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe09888",
  null
  
)

export default component.exports